<template>
  <div
    class=""
    :class="
      muted
        ? 'text-muted font-weight-bold mr-2'
        : 'label label-light-success font-weight-bolder label-inline mr-2 label-lg'
    "
  >
    {{ tag }}
  </div>
</template>

<script>
export default {
  name: "TagsPills",
  props: {
    tagId: { required: true },
    muted: { required: false }
  },
  computed: {
    tag() {
      let tag = this.$store.getters.getTags.find(t => t._id == this.tagId);
      return tag?.name;
    }
  }
};
</script>

<style scoped>
.label {
  margin-bottom: 5px;
}
</style>
